export default __webpack_public_path__ + "static/media/4.83499b19.jpg";